package com.essntl.features.supplier.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.uikit.components.iconbutton.destructive.EsMediumDestructiveIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun SupplierItem(
    supplierService: SupplierServiceModel,
    enabled: Boolean = true,
    onDeleteSupplier: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(RoundedCornerShape(16.dp))
            .background(color = MaterialTheme.esColorScheme.bgPrimary)
            .padding(1.5f.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.5f.spacing),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
            ) {
                Text(
                    text = supplierService.supplier.prettyName,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            }
        }

        EsMediumDestructiveIconButton(
            onClick = onDeleteSupplier,
            enabled = enabled,
            iconRes = EsIcons.Trash,
            modifier = Modifier
                .padding(
                    top = 1.spacing,
                    end = 1.spacing,
                ),
        )
    }
}